import Vue from "vue";
import Vuex from "vuex";
import { pauseVideoPlayer } from '../utils'
Vue.use(Vuex);

const userid = localStorage.getItem("userid");

export default new Vuex.Store({
  state: {
    // 当前播放的歌曲ID
    duetId: -1,
    // 当前播放的歌曲的资源地址
    musicSrc: null,
    activeTabIndex: 0, // 活跃的tab index
    authChecked: +localStorage.getItem(`${userid}_auth_status`) || 0, // 授权状态
    shareImg: "",
  },
  mutations: {
    pauseSongId(state) {
      state.duetId = -1;
      state.musicSrc = null;
    },
    playSongId(state, { duetId, originalMp3 }) {
      // 需要处理现在页面上正在播放的音频
      pauseVideoPlayer();
      state.duetId = duetId;
      state.musicSrc = originalMp3;
    },
    toggleTab(state, index) {
      state.activeTabIndex = index;
    },
    setShareImg(state, img) {
      state.shareImg = img;
    },
    toggleAuthChecked(state, { status, userid }) {
      state.authChecked = status;
      localStorage.setItem(`${userid}_auth_status`, status);
    },
  },
});
